/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="70.91"
        height="94.27"
        viewBox="0 0 70.91 94.27"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M35.35 74h5.25a1 1 0 0 0 1-1 .76.76 0 0 0 0-.21l-3-13.11a1.11 1.11 0 0 1 0-.19.9.9 0 0 1 .41-.76 6.65 6.65 0 1 0-7 0 .91.91 0 0 1 .4.76.58.58 0 0 1 0 .19l-3 13.11a1.49 1.49 0 0 0 0 .21 1 1 0 0 0 1 1Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M44.72 0a10.49 10.49 0 0 1 10.46 10.18v17.14a1.251 1.251 0 0 1-2.5.12v-17a8 8 0 0 0-7.72-8H26.19a8 8 0 0 0-8 7.72v5.13A1.25 1.25 0 0 1 17 16.6a1.27 1.27 0 0 1-1.25-1.13v-5A10.49 10.49 0 0 1 25.91 0h18.81Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M66.43 26.07H4.49A4.49 4.49 0 0 0 0 30.55v59.24a4.49 4.49 0 0 0 4.49 4.48h61.94a4.49 4.49 0 0 0 4.48-4.48V30.55a4.49 4.49 0 0 0-4.48-4.48Zm-61.94 2.5h61.94a2 2 0 0 1 2 2v59.24a2 2 0 0 1-2 2H4.49a2 2 0 0 1-2-2V30.55a2 2 0 0 1 2-1.98Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PadlockDisengagedIcon';

export default Icon;
